import React from 'react';
import { connect } from 'react-redux';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import RemoveCardConfirm from '../components/RemoveCardConfirm';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class RemoveConfirmScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES_PAPER_BIN,
            Breadcrumbs.MY_OUTSOURCES_PAPER_BIN_REMOVE,
            Breadcrumbs.MY_OUTSOURCES_PAPER_BIN_REMOVE_CONFIRM,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidMount() {
        if ( !this.props.enableRemove ) {
            window.history.back();
        }
    }

    render() {
        if ( !this.props.enableRemove ) {
            return null;
        }

        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_CONFIRMAR_ELIMINACION_DE_RECURSOS_DE_MIS_SUBCONTRATAS')} breadcrumbs={breadcrumbs}>
                <RemoveCardConfirm/>
            </PsPage>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let removeCount = 0;
    removeCount += state.remove.companies.length;
    removeCount += state.remove.workers.length;
    removeCount += state.remove.machines.length;
    return {
        enableRemove: removeCount > 0,
    };
};

export default connect(mapStateToProps)(RemoveConfirmScreen);



// WEBPACK FOOTER //
// ./src/app/remove/screens/RemoveConfirmScreen.js